import actions from './actions';
import mutations from './mutations';
import { emptyInventoryScope } from '../../js/inventoryScope';

const state = {
    accounts: [],
    services: [],
    displayServices: [],
    categories: [],
    displayCategories: [],
    activeRequest: null,
    activeRequests: [],
    securityGroups: [],
    accessSecurityGroups: [],
    requestPermissions: {
        export: false,
    },
    // Что пользователю доступно в разделе «Оборудование». Приходит из /v1/source-data
    // возможностями, а не ролями: фронт не знает ни про INVENTORY_MANAGER, ни про
    // городские группы. Значения по умолчанию закрытые — см. BOOT.
    inventoryPermissions: {
        view: false,
        edit: false,
        export: false,
        manage: false,
    },
    // Городская область раздела. Приходит не отсюда, а из /inventory/source-data
    // вместе со справочниками, и кладётся сюда мутацией SET_INVENTORY_SCOPE: область нужна
    // и списку, и карточке, и форме создания, а запрос у них общий и уже кэшируется.
    // Значение по умолчанию закрытое — см. inventoryScope.js.
    inventoryScope: emptyInventoryScope(),
    menuInfo: [],
};

export default {
    state,
    actions,
    mutations,
};
